module.exports = __webpack_public_path__ + "img/house-image-1.5948de22.jpg";